window.startupOffset = window.startupOffset || +new Date();

export function logWithOffset(message) {
  const diff = (+new Date()) - window.startupOffset;
  console.log(`[RTC +${diff}] ${message}`);
}


export function errorWithOffset(message) {
  const diff = (+new Date()) - window.startupOffset;
  console.error(`[RTC +${diff}] ${message}`);
}
